import { BaseModal, Container, useBreakpoint } from '@melio/penny';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { useLocation } from '@melio/platform-utils';
import { useSubscription } from '@melio/subscriptions-sdk';

import { SubscriptionPlansActivity } from '../SubscriptionPlans';

type SubscriptionPlansModalActivityProps = {
  isOpen: boolean;
  onClose?: () => void;
};

export const SubscriptionPlansModalActivity = ({ isOpen, onClose }: SubscriptionPlansModalActivityProps) => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);
  const { subscription } = useSubscription();
  const { isExtraSmallScreen } = useBreakpoint();
  const { pathname: returnUrl } = useLocation();
  const modalProps = {
    maxW: '1100px',
  };
  const hasPlan = !!subscription.planId;
  const modalPadding = isExtraSmallScreen ? 'm' : 'xxl';
  const isModalOpen = isOpen && isPlatformSubscriptionsEnabled;

  const handleOnClose = () => {
    if (hasPlan) {
      onClose?.();
    }
  };

  return (
    <BaseModal
      {...modalProps}
      isOpen={isModalOpen}
      onClose={handleOnClose}
      shouldHideCloseButton={!hasPlan}
      size="large"
      data-testid="subscription-plans-modal-activity"
    >
      <Container paddingX={modalPadding} paddingY={modalPadding} overflow="auto">
        <SubscriptionPlansActivity onFreePlanSubscribe={onClose} returnUrl={returnUrl} />
      </Container>
    </BaseModal>
  );
};
